import { useState } from "react";

export default function Accordian({ item }: { item: any }) {
  const [show, setShow] = useState(false);
  return (
    <>
      <a
        href="#!"
        className={`group text-light ${
          show && "bg-light/10 text-white"
        } hover:text-white hover:bg-light/10 flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold pr-16`}
        onClick={() => setShow(!show)}
      >
        <item.icon
          className={`h-6 w-6 my-auto shrink-0 ${
            show && "text-info"
          } group-hover:text-info`}
          aria-hidden="true"
        />
        {item.name}
      </a>
      {show && (
        <ul className="marker:text-light hover:marker:text-info list-disc pl-12 space-y-1">
          {item.collapse.map((x: any, idx: any) => (
            <li key={idx}>
              <a
                href={x.href}
                className="group text-light hover:text-white flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
              >
                {x.name}
              </a>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
